import {all} from 'redux-saga/effects';

import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  fetchMyTeams as fetchMyTeamsAction,
  fetchAllTeams as fetchAllTeamsAction,
  fetchStaffMembers as fetchStaffMembersAction,
  fetchPermissionEntities as fetchPermissionEntitiesAction,
  createTeam as createTeamAction,
  inviteNewStaffMember as inviteNewStaffMemberAction
} from './';

import {
  fetchMyTeams,
  fetchAllTeams,
  fetchPermissionEntities,
  createTeam,
  fetchStaffMembers,
  inviteNewStaffMember
} from 'sdk/teams';

function* teamsListSaga() {
  yield all([
    createFetchSagaLatest(fetchMyTeamsAction, fetchMyTeams),
    createFetchSagaLatest(fetchAllTeamsAction, fetchAllTeams),
    createFetchSagaLatest(fetchStaffMembersAction, fetchStaffMembers),
    createFetchSagaLatest(
      fetchPermissionEntitiesAction,
      fetchPermissionEntities
    ),
    createPostSagaLatest(createTeamAction, createTeam),
    createPostSagaLatest(inviteNewStaffMemberAction, inviteNewStaffMember)
  ]);
}

export default teamsListSaga;
